import { CreateSchemeComponent } from './create-scheme/create-scheme.component';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ExportDropdownBindDynamicParameter, StorageName } from '../../../shared/enum/common-enum';
import { CommonService } from '../../../shared/services/common.service';
import { StorageService } from '../../../shared/services/storage.service';
import { InstallmentEntryComponent } from './installment-entry/installment-entry.component';
import { ExcelConverterServiceService } from '../../../shared/services/excel-converter-service.service';
import { ReportService } from '../../report/report.service';
import { ModalPopupSize, VoucherType } from '../../../shared/models/common.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FundTransferWithdrawPopupComponent } from './popups/fund-transfer-withdraw-popup/fund-transfer-withdraw-popup.component';
import { SendDataService } from '../../../shared/services/send-data.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { InstallmentReportComponent } from './installment-report/installment-report.component';
import { LayawaysReportComponent } from './layaways-report/layaways-report.component';

@Component({
  selector: 'app-investment-fund',
  templateUrl: './investment-fund.component.html',
  styleUrls: ['./investment-fund.component.scss']
})
export class InvestmentFundComponent extends CommonService implements OnInit{
  @ViewChild(CreateSchemeComponent)createSchemeComponent : CreateSchemeComponent;
  @ViewChild(InstallmentEntryComponent)installmentEntryComponent : InstallmentEntryComponent;
  @ViewChild(InstallmentReportComponent)installmentReportComponent : InstallmentReportComponent;
  @ViewChild(LayawaysReportComponent)layawaysReportComponent : LayawaysReportComponent;

  exportDropdownBindDynamicParameter = ExportDropdownBindDynamicParameter;
  activeTabId: any;
  receivedData: string = "Save";
  isAddDetails:boolean=false;
  canDeleteOrUpdate:boolean=true;
  popupData: any;
  amount: any;
  fundTransferId:number;
  fundWithdrawId:number;
  layawaysData: any;
  invoiceDetailId: any;
  constructor(
    public storageService: StorageService,
    public renderer: Renderer2,
    public excelConverterServiceService: ExcelConverterServiceService,
    private reportService : ReportService,
    private modalService: NgbModal,
    public sendDataService: SendDataService,
    public notificationService: NotificationService,

  ) {
    super(renderer);}

  ngOnInit(): void {
    this.invoiceDetailId = this.storageService?.retrieve('InvestmentFundInvoiceId');
  };

saveSettings()
{
  if(!((this.createSchemeComponent?.formModel?.id ) ? this.sendDataService?.permissionVM?.investmentFundCanUpdate : this.sendDataService?.permissionVM?.investmentFundCanAdd)) return

    if(this.activeTabId==1 &&  this.isAddDetails==true){
      this.installmentEntryComponent?.insertinstallmentfundData();
   }
}

exportBindParameterBasedOnTab(value){
  switch(this.activeTabId){
    case (InvestmentFundTabs.installmentReport):
      switch(value){
        case ExportDropdownBindDynamicParameter.RequestModel:
          return this.installmentReportComponent?.apiRequestModel;
        case ExportDropdownBindDynamicParameter.GridApi:
          return [this.installmentReportComponent?.gridApiinstallmentreportDetailsList];
        case ExportDropdownBindDynamicParameter.GridName:
          return [StorageName.TRANSACTION_INSTALLMENTREPORT_DETAILS_GRID];
      }
    break;
    case (InvestmentFundTabs.layawaysReport):
      switch(value){
        case ExportDropdownBindDynamicParameter.RequestModel:
          return this.layawaysReportComponent?.apiRequestModel;
        case ExportDropdownBindDynamicParameter.GridApi:
          return [this.layawaysReportComponent?.gridApi];
        case ExportDropdownBindDynamicParameter.GridName:
          return [StorageName.TRANSACTION_LAYAWAYSREPORT_GRID];
      }
    break;
  }}


  callApiForExport() {
    switch(this.activeTabId){
      case InvestmentFundTabs.installmentReport:
        this.installmentReportComponent?.callApiForExport();
      break;
      case InvestmentFundTabs.layawaysReport:
        this.layawaysReportComponent?.callApiForExport();
      break;
    }}

onReceiviInstallMent(data: boolean) {
  this.isAddDetails = data;
}

handleDataAndRow(event: { data: any, amount:number , fundTransferId:number,fundWithdrawId:number}) {
  this.popupData = event?.data;
  this.amount = event?.amount;
  this.fundTransferId=event?.fundTransferId;
  this.fundWithdrawId=event?.fundWithdrawId;
}

onTabChange(event){
  this.activeTabId = event?.nextId;
   this.receivedData = this.activeTabId== 1 && this.receivedData == 'Update' ? 'Save' : 'Save';
   if(this.activeTabId==2)
    this.isAddDetails =false;
}
newcreateScheme(){
  this.createSchemeComponent.newCreateScheme();
}

openFundWithdrawOrTransferPopup(Title) {
  var formModelForWithdrawPopup: any = {};
  formModelForWithdrawPopup.invoiceModel = {};
  formModelForWithdrawPopup.invoiceModel.accountledgerid = this.popupData?.accountLedgerId;
  formModelForWithdrawPopup.invoiceModel.accountLedgerName = this.popupData?.accountLedgerName;
  formModelForWithdrawPopup.invoiceModel.againstVoucherNo = this.popupData?.id;
  formModelForWithdrawPopup.invoiceModel.amount = this.amount;
  formModelForWithdrawPopup.invoiceModel.againstVoucherTypeId = VoucherType.InvestmentFund;
  formModelForWithdrawPopup.invoiceModel.againstInvoiceNo = '';
  var data = {
    modalTitle: Title,
    formModel: formModelForWithdrawPopup,
    formModelForWithdrawPopup: formModelForWithdrawPopup,
    FundTransferOrWithdraw: Title === 'Fund Transfer' ? FundTransferOrWithdraw.FundTransfer : Title === 'Fund Withdraw' ? FundTransferOrWithdraw.FundWithdraw : undefined,
    fundTransferId: this.fundTransferId,
    fundWithdrawId: this.fundWithdrawId
  };
  this.notificationService.openModalPopup(FundTransferWithdrawPopupComponent, data, Title, ModalPopupSize.LG, "", false)
    .then((result) => {
      if (result) {
        this.installmentEntryComponent?.reFillData();
          
      }
    });
}


isFundWithdrawDisabled(): boolean {
  if (this.installmentEntryComponent?.formModel?.fundUsedInInvoiceNo !== 0 && this.installmentEntryComponent?.formModel?.fundUsedInInvoiceNo !== null) {
    return true; 
  }
  if (this.installmentEntryComponent?.formModel?.fundWithdrawId === 0) {
    
    if (
      this.installmentEntryComponent?.formModel?.fundTransferId === 0 &&
      (this.installmentEntryComponent?.formModel?.fundUsedInInvoiceNo === 0 || this.installmentEntryComponent?.formModel?.fundUsedInInvoiceNo === null)
    ) {
      return false; 
    }
    return true; 
  }
  
  return false; 
}
isfundTransferDisabled(): boolean {
  if (this.installmentEntryComponent?.formModel?.fundUsedInInvoiceNo !== 0 && this.installmentEntryComponent?.formModel?.fundUsedInInvoiceNo !== null && this.installmentEntryComponent?.formModel?.fundUsedInInvoiceNo != '') {
    return true; 
  }

   if(this.installmentEntryComponent?.formModel?.footerCalculation && this.installmentEntryComponent?.formModel?.fundTransferId === 0){
    if(this.installmentEntryComponent?.formModel?.footerCalculation?.paidInstallments === 0){
      return true
    }else{
      const [paid, total] = this.installmentEntryComponent?.formModel?.footerCalculation?.paidInstallments.split('/').map(Number);
      if(paid === 0)
      return true;
    }

  }

  if (this.installmentEntryComponent?.formModel?.fundTransferId === 0) {
    
    if (
      this.installmentEntryComponent?.formModel?.fundWithdrawId === 0 &&
      (this.installmentEntryComponent?.formModel?.fundUsedInInvoiceNo === 0 || this.installmentEntryComponent?.formModel?.fundUsedInInvoiceNo === null)
    ) {
      return false; 
    }
    return true; 
  }
  
  return false; 
}

isButtonDisabled(): boolean {
  if(this.installmentEntryComponent?.formModel?.footerCalculation){
    const [paid, total] = this.installmentEntryComponent?.formModel?.footerCalculation?.paidInstallments.split('/').map(Number);
    return paid === 0;
  }

}

openAdvanceFilterPopUp(){
  switch (this.activeTabId) {
    case 2:
      this.installmentReportComponent?.openAdvanceFilterPopUp()
      break;
    case 3:
      this.layawaysReportComponent?.openAdvanceFilterPopUp()
      break;
  }
}

resetFilter(){
  switch (this.activeTabId) {
    case 2:
      this.installmentReportComponent?.resetFilter();
      break;
    case 3:
      this.layawaysReportComponent?.resetFilter();
      break;
  }
}
  openConfirmationPopup() {
    this.installmentEntryComponent.openConfirmationPopup();
  }

  getLayawaysDetails(data) {
    this.activeTabId = InvestmentFundTabs.purchase;
    this.invoiceDetailId =undefined
    this.layawaysData = data;
  }

  ngOnDestroy() {
    this.storageService.removeItem('InvestmentFundInvoiceId');
  }
}
export enum InvestmentFundTabs {
  purchase=1,
  installmentReport =2,
  layawaysReport =3
}

export enum FundTransferOrWithdraw{
  FundTransfer = 1,
  FundWithdraw = 2,
}
